import {isBackspaceKeyCode, isDeleteKeyCode, isNumericKey, isUndoKeyCode} from "../../../../../helpers/keyboardHelper";

import EventManager from "../../../store/sqftEventManager";
import store from "../../../../../../../store";
import {
  FREE_DRAW_TYPE,
  FREE_FORM_THICKNESS_POPUP_ID, MEASURE_UNITS,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS, SIDEBAR_SHAPE_BUTTONS
} from "../../../../../constants";
import {getFreeDrawPoint, getLockedPoint, getLockPointPos} from "../../../helpers/freeDrawHelper";
import {
  getIntersectCordsBetweenLines,
  getMidPoint,
  getMousePositionOnField,
  getPointDistance,
  getPointOnTheLine,
  mmToInches
} from "../../../../../helpers/sqftHelper";
import NumberText from "../../workspace/text/numberText";
import workspace from "../../workspace";
import ShapeHelper, {getLineLengthNumberText} from "../../../../../helpers/shapeHelper";
import Config, {MIN_DISTANCE_BETWEEN_FREE_DRAW_POINTS} from "../../../store/sqftConfig";
import {
  deleteChangeValuePopup,
  setSQFTActiveButton,
  setSQFTMenuOpened
} from "../../../../../../../actions/sqftMenuFunctions";
import config from "../../../store/sqftConfig";
import RenderFreeDraw from "../../../helpers/renderFreeDraw";
import sqftConfig from "../../../store/sqftConfig";
import {closeAdjustableInput} from "../../../../../helpers/uiHelper";

export class BaseDraw {
  clickedBackSplashButton = null;
  arcLength = 0;
  angle = 0;
  minDistanceBetweenFreeDrawPoints = MIN_DISTANCE_BETWEEN_FREE_DRAW_POINTS;

  constructor() {
    this.state = {
      isDrawFinished: false,
      addedPoints: [],
      dimensions: [],
      dimensionToMouse: null,
      drawLineToMouse: false,
      lineWidth: 2,
      lineColor: null,
      outlineColor: null,
      minLineLength: 15,
      drawType: null,
      useLockedPoints: true,
      currentNumericInput: "",
      lockedAngleStep: 45
    };
  }

  getState = () => this.state

  onMouseMove = (mousePos, e) => {
    void e;

    if (this.state.addedPoints.length > 0) {
      this.state.drawLineToMouse = true;

      if (!this.state.dimensionToMouse) {
        this.createDimensionToMouse();
      }
      this.updateMeasurementToMousePosition(mousePos);
    }

    if (this.state.currentNumericInput.length >= 1 ) {
      this.state.currentNumericInput = "";
    }
  }

  onKeyDown = (code, e) => {
    // Handle Ctrl+Z for undo
    if (isUndoKeyCode(e)) {
      e.preventDefault(); // prevent browser undo
      this.undoLastPoint();
      return false;
    }

    if (isNumericKey(e)) {
      let newValue = this.state.currentNumericInput + e.key
      if (!isNaN(+newValue)) {
        this.state.currentNumericInput = newValue;
        if (this.state.dimensionToMouse) {
          if (sqftConfig.measureUnit === MEASURE_UNITS.Metric) {
            newValue = mmToInches(newValue);
          }
          this.state.dimensionToMouse.value = newValue;
        }
      }
      console.log("currentNumericInput", this.state.currentNumericInput);
      //return true;
      return false;
    }

    if (isBackspaceKeyCode(e) || isDeleteKeyCode(e)) {
      if (this.state.currentNumericInput.length >= 1) {
        let newValue = this.state.currentNumericInput.slice(0, -1);
        this.state.currentNumericInput = newValue
        if (sqftConfig.measureUnit === MEASURE_UNITS.Metric) {
          newValue = mmToInches(newValue);
        }
        this.state.dimensionToMouse.value = newValue;
        console.log("currentNumericInput", this.state.currentNumericInput);
      }
      return false;
    }

    if (code === EventManager.keyCode.ENTER || code === EventManager.keyCode.NumpadEnter) {
      if (this.state.addedPoints.length > 0) {
        if (this.state.currentNumericInput) {
          this.createPointFromCurrentNumericInput();
          this.state.currentNumericInput = "";
        } else {
          if (this.isMousePosFitDistanceWithLastPoint(EventManager.LastKnownMousePos)) {
            const pointV2 = this.getPointFromMousePosition(EventManager.LastKnownMousePos);
            this.state.addedPoints.push(pointV2);
          }
          this.drawFinish();
          this.state.isDrawFinished = true;
          this.init();
        }
      }
    }

    return true;
  }

  onMouseDown = (mousePos) => {
    // var hoverPoint = workspace.getHoverPoint();
    // var hoverShape = workspace.getHoverShape();
    // if (hoverPoint || hoverShape) {
    //   return true;  // return true; // block all mouse-down events // we need dragging workspace
    // }
    this.state.currentNumericInput = "";
    const reduxState = store.getState();
    const activeButton = reduxState.sqftMenuState.activeButton;
    //todo pointV2 priority should be higher
    // const hoverPoint = workspace.getHoverPointV2();
    // const wall = WallsManager.getWallByPoint(hoverPoint);
    if (activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall) {
      this.drawWall(mousePos);
      return true;
    }
  };

  onMouseUp = (mousePos) => {
    void mousePos;

    // this.checkForRestoreCursor();
    //
    // var hoverPoint = workspace.getHoverPoint();
    // var hoverShape = workspace.getHoverShape();
    // if (hoverPoint && !hoverPoint.angleIsChanged) {
    //
    //   if (this.arcLength) {
    //     hoverPoint.arcLength = this.arcLength;
    //     hoverPoint.angle = 0;
    //   } else if (this.angle) {
    //     hoverPoint.angle = this.angle;
    //     hoverPoint.arcLength = 0;
    //   }
    //   return true;
    // } else if (hoverShape) {
    //   Menu.openMenu();
    //   return true;  // if click on shape, block reseting cursor, because we still need it http://jira.mozidev.com/browse/QC-956
    // }/* else {
    //     deregisterEvents();
    //     elements.designDefault.click();
    //   }*/
  };

  onDblClick = (mousePos) => {
    const reduxState = store.getState();
    const activeButton = reduxState.sqftMenuState.activeButton;
    if (activeButton === SIDEBAR_SHAPE_BUTTONS.shapeFreeForm
      && !workspace.getHoverPoint()
    ) {
      void mousePos
      this.state.isDrawFinished = true;
      this.drawFinish();
      return false;
    }
  }

  // Undo the last added point
  undoLastPoint = () => {
    // Check if there are points to undo
    if (this.state.addedPoints.length === 0) {
      return;
    }

    // Remove and destroy the last point
    const lastPoint = this.state.addedPoints.pop();
    if (lastPoint && lastPoint.destroy) {
      lastPoint.destroy();
    }

    // Remove and destroy the last dimension
    if (this.state.dimensions.length > 0) {
      const lastDimension = this.state.dimensions.pop();
      if (lastDimension && lastDimension.destroy) {
        lastDimension.destroy();
      }
    }

    // Reset current numeric input
    this.state.currentNumericInput = "";
    closeAdjustableInput();

    // Handle dimensionToMouse
    if (this.state.dimensionToMouse) {
      this.state.dimensionToMouse.destroy();
      this.state.dimensionToMouse = null;
    }

    // If there are still points left, recreate dimensionToMouse
    if (this.state.addedPoints.length > 0) {
      this.createDimensionToMouse();
      this.state.drawLineToMouse = true;

      // Update dimension to current mouse position
      const mousePos = EventManager.getMousePos();
      if (mousePos) {
        this.updateMeasurementToMousePosition(mousePos);
      }
    } else {
      this.state.drawLineToMouse = false;
    }

    console.log("Undo last point. Remaining points:", this.state.addedPoints.length);
  }

  createPointFromCurrentNumericInput = () => {
    const mousePos = EventManager.getMousePos();
    const lastPoint = this.state.addedPoints[this.state.addedPoints.length - 1];
    let distance = parseFloat(this.state.currentNumericInput);
    if (sqftConfig.measureUnit === MEASURE_UNITS.Metric) {
      distance = mmToInches(distance);
    }
    let newPoint;
    if (this.state.useLockedPoints && this.isPointExist()) {
      newPoint = getLockedPoint(lastPoint, mousePos, this.state.lockedAngleStep);
    } else {
      newPoint = getFreeDrawPoint(mousePos);
    }

    // We take full distance and subtract existing point distance from it
    const segmentLength = getPointDistance(newPoint, lastPoint);
    const newCordsAtDistance = getPointOnTheLine(newPoint, lastPoint, distance - segmentLength);
    newPoint.setPosition(newCordsAtDistance);
    this.drawStart(mousePos, newPoint);
  }

  updateMeasurementToMousePosition = (mousePos) => {
    if (this.state.addedPoints.length > 0) {
      const mPosOnField = getMousePositionOnField(mousePos.x, mousePos.y);
      const lastPoint = this.state.addedPoints[this.state.addedPoints.length - 1];
      const distance = getPointDistance(mPosOnField, lastPoint);
      const reduxState = store.getState();
      const isWallsLockMode = reduxState.sqftMenuState.isWallsLockMode;
      const activeButton = reduxState.sqftMenuState.activeButton;
      let midPoint;

      if (isWallsLockMode && activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall) {
        const lockedPointPos = getLockPointPos(lastPoint);
        const lockPointOnField = getMousePositionOnField(lockedPointPos.x, lockedPointPos.y);
        midPoint = getMidPoint(lockPointOnField, lastPoint);
        this.state.dimensionToMouse.pos.betweenPoints.pointTo = lockPointOnField
      } else {
        if (this.state.useLockedPoints) {
          const lockedPointPos = getLockPointPos(lastPoint, this.state.lockedAngleStep);
          const lockPointOnField = getMousePositionOnField(lockedPointPos.x, lockedPointPos.y);
          midPoint = getMidPoint(lockPointOnField, lastPoint);
        } else {
          midPoint = getMidPoint(mPosOnField, lastPoint);
        }

        this.state.dimensionToMouse.pos.betweenPoints.pointTo = getMousePositionOnField(mousePos.x, mousePos.y);
      }
      this.state.dimensionToMouse.pos.betweenPoints.pointFrom = lastPoint;
      this.state.dimensionToMouse.pos.x = midPoint.x;
      this.state.dimensionToMouse.pos.y = midPoint.y;
      this.state.dimensionToMouse.value = distance;

      // console.log("this.state.dimensionToMouse", this.state.dimensionToMouse);
      // debugger // eslint-disable-line no-debugger
    }
  }

  init = () => {
    if (!this.state.isInited) {
      this.state.isInited = true;
      this.createDimensionToMouse();
      this.registerEvents();
    }
  };

  createDimensionToMouse = () => {
    this.state.dimensionToMouse = new NumberText(
      0,
      {x: 0, y: 0},
      {shouldRenderFrameBorder: true, isLength: true, isInputDisabled: true},
      workspace,
      Function(),
      true
    );
  }

  registerEvents = () => {
    EventManager.addEvent(
      EventManager.events.RENDER,
      this.render,
      this,
      EventManager.priorities.SHAPE
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_DOWN,
      this.onMouseDown,
      this,
      EventManager.priorities.WALL
    );
    EventManager.addEvent(
      EventManager.events.DBLCLICK,
      this.onDblClick,
      this,
      EventManager.priorities.WALL
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_MOVE,
      this.onMouseMove,
      this,
      EventManager.priorities.IMAGE
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_UP,
      this.onMouseUp,
      this,
      EventManager.priorities.OVERALL
    );
    EventManager.addEvent(
      EventManager.events.KEYDOWN,
      this.onKeyDown,
      this,
      EventManager.priorities.OVERALL
    );
  };

  hide = function(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  deregisterEvents = () => {
    closeAdjustableInput();
    EventManager.resetCursor(this);
    EventManager.removeEvent(this);
  }

  destroy = (protect, revertBackAfterMouseUp) => {
    if (revertBackAfterMouseUp) {
      EventManager.removeEvent(this, EventManager.events.RENDER);
      this.isWaitingToRestoreCursor = true;
    } else {
      this.deregisterEvents();
    }
    this.hide();
  };

  checkIfFirstPointHovered = () => {
    return this.state.addedPoints.length > 2 && this.state.addedPoints[0].modelCorePoint.mixins.movable.isHovering();
  }

  checkIfThisIsSecondPoint = () => {
    return this.state.addedPoints.length === 1;
  }

  isPointExist = () => {
    return this.state.addedPoints.length >= 1;
  }

  isFitDistanceWithLastPoint = (point) => {
    if (this.state.addedPoints.length < 1) {
      return true
    }
    const distance = getPointDistance(point, this.state.addedPoints[this.state.addedPoints.length - 1]);

    return distance > this.minDistanceBetweenFreeDrawPoints
  }

  isMousePosFitDistanceWithLastPoint = (mousePos) => {
    const mousePosOnField = getMousePositionOnField(mousePos.x, mousePos.y);
    return this.isFitDistanceWithLastPoint(mousePosOnField);
  }

  initDraw = (useLockedPoints) => {
    this.state.useLockedPoints = useLockedPoints
  }

  getPointFromMousePosition = (mousePos) => {
    let point;
    if (this.state.useLockedPoints && this.isPointExist()) {
      const lastPoint = this.state.addedPoints[this.state.addedPoints.length - 1];
      point = getLockedPoint(lastPoint, mousePos, this.state.lockedAngleStep);
    } else {
      point = getFreeDrawPoint(mousePos);
    }
    return point
  }

  drawStart = (mousePos, pointV2) => {
    if (!this.isMousePosFitDistanceWithLastPoint(mousePos)) {
      if (pointV2 && pointV2.destroy) {
        pointV2.destroy();
      }
      return
    }

    if (this.state.addedPoints.length > 0) {
      this.addLineDimensions(pointV2);
    }
    this.state.addedPoints.push(pointV2);
    this.state.dimensionToMouse ? this.state.dimensionToMouse.destroy() : null;
    this.state.dimensionToMouse = null;
  };

  addLineDimensions = (pointTo) => {
    //const prevPoint = this.state.addedPoints[this.state.addedPoints.length - 2];
    const pointFrom = this.state.addedPoints[this.state.addedPoints.length - 1];
    const numberText = getLineLengthNumberText(
      pointFrom,
      pointTo,
      workspace,
      this.setSegmentLengthFromNumberValue,
      {isInputDisabled: true}
    );//new NumberText(thicknessValue, posThickness, {}, this, this.setSegmentThicknessFromNumberValue);

    this.state.dimensions.push(numberText);
  };

  setSegmentLengthFromNumberValue = (value, numberText) => {
    const miteredSection = numberText.parent;
    if (!miteredSection || typeof miteredSection.getSegments !== 'function') {
      return;
    }
    value = Math.round(+value / Config.getMeasureMultiplier() * 100) / 100;
    let miteredSegments = miteredSection.getSegments();
    let miteredSegment = miteredSegments.find(seg => seg.length === numberText);

    this.setSegmentLength(value, miteredSegment, miteredSection);
  };

  resetState = (shouldResetPoints = true) => {
    this.state.isDrawFinished = false;
    closeAdjustableInput();
    if (shouldResetPoints) {
      for (const addedPoint of this.state.addedPoints) {
        addedPoint.destroy();
      }
    }
    for (const dimension of this.state.dimensions) {
      dimension.destroy();
    }
    if (this.state.dimensionToMouse) {
      this.state.dimensionToMouse.destroy();
    }

    this.state.addedPoints = [];
    this.state.dimensions = [];
  };

  drawFinish = () => {
    //if (this.state.useLockedPoints) {
    //  this.changeFirstPointCoordinatesToCreate45or90DegAngleWithTheLastPoint();
    //}
    //this.addLineDimensions(this.state.addedPoints[0], this.state.addedPoints[1]);
    const reduxState = store.getState();
    const activeButton = reduxState.sqftMenuState.activeButton;
    const figureCanHaveOnly2Points = [FREE_DRAW_TYPE.wall, FREE_DRAW_TYPE.shapeFreeForm].includes(this.state.drawType);
    if (this.state.addedPoints.length > 2
      || figureCanHaveOnly2Points && this.state.addedPoints.length === 2
    ) {
      const shapeCenter = ShapeHelper.getCenterPoint(this.state.addedPoints);
      let preparedPoints = [];
      for (const addedPoint of this.state.addedPoints) {
        addedPoint.x -= shapeCenter.x;
        addedPoint.y -= shapeCenter.y;
        preparedPoints.push(addedPoint);
      }
      switch (this.state.drawType) {
        case FREE_DRAW_TYPE.wall:
          this.createFigureFromPoints(preparedPoints, shapeCenter);
          break;
        case FREE_DRAW_TYPE.shape:
          this.createFigureFromPoints(preparedPoints, shapeCenter);
          store.dispatch(setSQFTMenuOpened(""));
          store.dispatch(setSQFTActiveButton(""));
          config.workspace.menuItemActive = "";
          this.deregisterEvents();
          break;
        case FREE_DRAW_TYPE.shapeFreeForm:
          this.createFigureFromPoints(preparedPoints, shapeCenter);
          store.dispatch(setSQFTMenuOpened(""));
          store.dispatch(setSQFTActiveButton(""));
          store.dispatch(deleteChangeValuePopup(FREE_FORM_THICKNESS_POPUP_ID));
          config.workspace.menuItemActive = "";
          this.deregisterEvents();
          break;
      }

      this.state.dimensionToMouse ? this.state.dimensionToMouse.destroy() : null;
      this.state.dimensionToMouse = null;
    }

    this.resetState(!(this.state.drawType === FREE_DRAW_TYPE.wall));
    this.deregisterEvents();

    if (activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall) {
      this.init();
    }
    this.state.isInited = false
  };

  createFigureFromPoints(preparedPoints, shapeCenter) {
    void preparedPoints;
    void shapeCenter;
  }

  changeFirstPointCoordinatesToCreate45or90DegAngleWithTheLastPoint = () => {
    if (this.state.addedPoints.length >= 2) {
      const firstPoint = this.state.addedPoints[0];
      const secondPoint = this.state.addedPoints[1];
      const lastPoint = this.state.addedPoints[this.state.addedPoints.length - 1];
      //const penultimatePoint = this.state.addedPoints[this.state.addedPoints.length - 2];
      const lockPointPos = getLockPointPos(lastPoint, this.state.lockedAngleStep, firstPoint.getPointField());
      const intersectionPoint = getIntersectCordsBetweenLines(
        firstPoint.getPointField(),
        secondPoint.getPointField(),
        lastPoint.getPointField(),
        lockPointPos,
        true,
        true
      );

      if (intersectionPoint) {
        const intersectionPointOnField = getMousePositionOnField(intersectionPoint.x, intersectionPoint.y);
        this.state.addedPoints[0].setPosition(intersectionPointOnField);
      }
    }
  }

  getOffset = function() {
    // //return {x: 0, y: 0};
    // var scale = sqftConfig.scale;
    // var workspacePos = workspace.getOffset();
    // debugger
    // if (parent) {
    //   var _pos = parent.getPosition();
    //   // if (sqftConfig.workspace.snapToGrid){
    //   //   _pos = parent.getSnappedPosition();
    //   // }
    //   var offset = {
    //     x: workspacePos.x + (_pos.x * scale),
    //     y: workspacePos.y + (_pos.y * scale)
    //   }
    // } else {
    //   return {x: 0, y: 0};
    // }
    // return offset;
  };

  render = (ctx) => RenderFreeDraw.render(ctx, this.getState())
}
